angular.module('elfium').service('elfiumSpinnerService', ['usSpinnerService', function (usSpinnerService) {
    var that = this;
    that._numberOfConcurrentRequests = 0;
    that.spin = function () {
        if (that._numberOfConcurrentRequests == 0) {
            usSpinnerService.spin('spinner');
        }
        that._numberOfConcurrentRequests++;
    };
    that.stop = function () {
        that._numberOfConcurrentRequests--;
        if (that._numberOfConcurrentRequests == 0) {
            usSpinnerService.stop('spinner');
        }
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumSpinnerService.ts